export const USER = "user"
export const ADMIN = "admin"
export const MANAGER = "manager"
export const ALL_PEOPLE = "all"
export const DEACTIVATED_PEOPLE = "deactivated"

export const FILTER_OPTIONS_NO_DEACTIVATED = [
  {label: "admin.constants.filter.activePeople.label", value: USER},
  {label: "admin.constants.filter.adminOnly.label", value: ADMIN}
]

export const FILTER_OPTIONS_WITH_MANAGERS = [
  {label: "admin.constants.filter.activePeople.label", value: USER},
  {label: "admin.constants.filter.adminOnly.label", value: ADMIN},
  {label: "admin.constants.filter.managerOnly.label", value: MANAGER}
]

export const FILTER_OPTIONS = FILTER_OPTIONS_NO_DEACTIVATED.concat([
  {label: "admin.constants.filter.managerOnly.label", value: MANAGER},
  {label: "admin.constants.filter.deactivatedPeople.label", value: DEACTIVATED_PEOPLE},
  {label: "admin.constants.filter.allPeople.label", value: ALL_PEOPLE}
])
